import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateShippingAddressMutation = createMutationHook(
  OrderApiClient.updateShippingAddress,
  {
    mutationKey: ['updateShippingAddress'],
  },
)
